export default __webpack_public_path__ + "8238ad5ac814eb11ee9281b8747e1fce.png";